import type { TrackDef } from '../track';
import { autoGates } from './util';

/**
 * Riviera Harbour: tribute to round 2, Monaco – Monte Carlo (design.md A5.2).
 * Traced from the original's map: top straight, the long run down the
 * right, the swimming-pool wiggle at the bottom, back up the middle and a
 * tight hairpin before the climb back to the line. Walls everywhere.
 */
const centerline: [number, number][] = [
  [17, 1], [43, 1], [43, 42], [45, 44], [52, 44], [55, 42.5], [60, 44], [64, 46],
  [66, 49], [65, 51.5], [60, 52.5], [56, 54.5], [56, 56.5], [64, 56.5], [66, 59], [66, 63],
  [47, 63.5], [43, 61.5], [39, 58.5], [37, 55.5], [36, 52], [35, 49], [35, 29], [31, 26.5],
  [31, 22.5], [35, 19.5], [35, 12], [29, 10.5], [22, 10], [18, 7.5], [15, 8.5], [12, 11],
  [10, 13], [9.5, 16], [6, 16.5], [5.5, 5.5], [9, 4.5], [14, 3],
];

export const RIVIERA_HARBOUR: TrackDef = {
  id: 'riviera-harbour',
  name: 'RIVIERA HARBOUR',
  subtitle: 'Tribute to Monte Carlo',
  country: 'MONACO',
  theme: 'riviera',
  scale: 27.5,
  offset: [5, 5],
  centerline,
  roadWidth: 62,
  kerbWidth: 5,
  runoffWidth: 8,
  runoffSurface: 'dust',
  gates: autoGates(centerline, 0, 0.45, 6),
  carparks: [],
  raceLaps: 3,
  defaultRecord: 33.5,
};
